import { Printer } from '../masterdata/models/printer';

export class EchoFileRequest{
    containerBarcode: string;
    labId: string;
    state: string;
    printer : Printer;
}